import { render, staticRenderFns } from "./ProductPivot.vue?vue&type=template&id=5c1d43ef&scoped=true&"
import script from "./ProductPivot.vue?vue&type=script&lang=js&"
export * from "./ProductPivot.vue?vue&type=script&lang=js&"
import style0 from "./ProductPivot.vue?vue&type=style&index=0&id=5c1d43ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1d43ef",
  null
  
)

export default component.exports